import React from "react";
import { ICONS } from "../../helpers/helper";
import { ResultLine, DetailLine, InfowinLine } from "./Mixin";

const socialList = [
  {
    label: "Facebook",
    value: "fb",
    icon: ICONS.FB,
  },
  {
    label: "Twitter",
    value: "tw",
    icon: ICONS.TW,
  },
  {
    label: "Instagram",
    value: "ins",
    icon: ICONS.INS,
  },
  {
    label: "Youtube",
    value: "ytb",
    icon: ICONS.YTB,
  },
];

const SocialButton = (props) => {
  const { value, url, label, icon } = props;
  if (!url) return null;

  return (
    <div className={`cbmap-social-icon cbmap-social-icon_${value}`}>
      <a
        href={url}
        title={label}
        target={`_blank`}
        className={`cbmap-social-icon-link cbmap-social-icon-link-${value}`}
        dangerouslySetInnerHTML={{
          __html: icon,
        }}
      ></a>
    </div>
  );
};


export const SocialsResult = (props) => {
  const {
    item,
  } = props;
  if(!socialList.find((social) => (!!item.properties[social.value]))) return null;
  return (
    <ResultLine className="cbmap-item_socials">
      {socialList.map((social) => (
        <SocialButton
          key={social.value}
          {...social}
          url={item.properties[social.value]}
        />
      ))}
    </ResultLine>
  );
};

export const SocialsDetail = (props) => {
  const {
    item,
  } = props;
  if(!socialList.find((social) => (!!item.properties[social.value]))) return null;

  return (
    <DetailLine className="cbmap-details_socials">
      {socialList.map((social) => (
        <SocialButton
          key={social.value}
          {...social}
          url={item.properties[social.value]}

        />
      ))}
    </DetailLine>
  );
};

export const SocialsInfowin = (props) => {
  const {
    item,
  } = props;
  if(!socialList.find((social) => (!!item.properties[social.value]))) return null;

  return (
    <InfowinLine className="cbmap-infowin_socials">
      {socialList.map((social) => (
        <SocialButton
          key={social.value}
          {...social}
          url={item.properties[social.value]}
        />
      ))}
    </InfowinLine>
  );
};
